import { SmartCollectionResponse } from 'api/product/getSmartCollection/types';
import { CollectionSorting } from 'constants/collection';
import { UrlQuery } from 'constants/url-query';
import { useCart } from 'contexts/cart';
import { usePetContext } from 'contexts/pet';
import { usePetProfile } from 'contexts/pet-profile';
import { useSegmentationContext } from 'contexts/segmentation';
import useOverrideProps from 'hooks/use-override-props';
import React, { useState } from 'react';
import Collection from './collection';
import useCollectionProps from './hooks/use-collection-props';
import { CollectionProvider } from './state';

interface PropTypes {
  handle: string;
  collection: SmartCollectionResponse;
  sortBy?: string;
  tags?: string[];
  hasH1title: boolean;
}

const CollectionWrapper: React.FC<PropTypes> = ({
  collection,
  handle,
  sortBy,
  tags,
  hasH1title,
}) => {
  const { current: currentPetType } = usePetContext();
  const { petProfile } = usePetProfile();
  const { multipleSegmentation } = useSegmentationContext();
  const { couponCode } = useCart();

  const [applyPetProfile, setApplyPetProfile] = useState(false);

  const { providerProps } = useCollectionProps({
    petProfile,
    applyPetProfile,
    handle,
    segmentation: multipleSegmentation,
    currentPetType,
  });

  const { providerPropsOverride, setFilterTags } = useOverrideProps({
    providerProps,
    isCat: currentPetType === 'cats',
  });

  const additionalQuery = applyPetProfile
    ? { [UrlQuery.multiSegmentMode]: '1' }
    : undefined;

  /** Type gard and this shouldn't happen here  */
  if (!providerPropsOverride) {
    throw new Error('unexpected input');
  }

  return (
    <CollectionProvider
      tags={tags}
      collection={collection}
      sortBy={sortBy as CollectionSorting | undefined}
      setUsedTags={setFilterTags}
      trackingListName={collection.title}
      applyPetProfile={applyPetProfile}
      couponCode={couponCode || undefined}
      {...providerPropsOverride}
    >
      <Collection
        setApplyPetProfile={(value: boolean) => {
          setApplyPetProfile(value);
        }}
        hasH1title={hasH1title}
        handle={handle}
        additionalQuery={additionalQuery}
      />
    </CollectionProvider>
  );
};

export default CollectionWrapper;
